// extracted by mini-css-extract-plugin
module.exports = {"font":"simpleStyling_font__aTKwS","time":"simpleStyling_time__KyAU6","label":"simpleStyling_label__50znC"};